import React from 'react';
import { Box, Typography } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';
import { RISK_RAMP } from './scoreGuidance';

export const ScoreLegend = () => {
	const { t } = useGlobalization();
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
			<Typography
				sx={{
					fontSize: 11,
					fontWeight: 700,
					letterSpacing: '0.06em',
					textTransform: 'uppercase',
					color: '#97a0ac',
				}}>
				{t('Score scale')}
			</Typography>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 1.5,
					flexWrap: 'wrap',
				}}>
				<Box
					sx={{
						width: 220,
						height: 10,
						borderRadius: '5px',
						background: RISK_RAMP,
					}}
				/>
				<Typography sx={{ fontSize: 12, color: '#9aa2ad' }}>
					{t('low risk → high risk')}
				</Typography>
			</Box>
			<Typography sx={{ fontSize: 12, color: '#7c879a' }}>
				{t(
					'Scale adapts to your model. Use the same range for all likelihood components, and the same for all consequence components.',
				)}
			</Typography>
		</Box>
	);
};

export default ScoreLegend;
